import { render, staticRenderFns } from "./ModalBulkUpdate.vue?vue&type=template&id=1a9cddb7&scoped=true&"
import script from "./ModalBulkUpdate.vue?vue&type=script&lang=ts&"
export * from "./ModalBulkUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBulkUpdate.vue?vue&type=style&index=0&id=1a9cddb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9cddb7",
  null
  
)

export default component.exports